import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const CourseVolumeInfo = ({ volumeNumber, totalLessons, classObject, isNotGenerated }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.title, isNotGenerated && styles.titleGray) },
            "Vol.",
            volumeNumber),
        React.createElement("div", { className: css(styles.daysCount) }, totalLessons ? (`${totalLessons}Lessons`) : (React.createElement(React.Fragment, null,
            "\u524D\u306EVolume\u304C\u5B8C\u4E86\u3059\u308B\u3068\u81EA\u52D5\u3067\u767B\u5834\uD83D\uDCAA",
            React.createElement("br", null),
            "\u597D\u304D\u306A\u30EC\u30C3\u30B9\u30F3\u3092\u304A\u6C17\u306B\u5165\u308A\u2661\u3059\u308B\u307B\u3069\u3001\u3042\u306A\u305F\u306B\u5408\u3063\u305F\u30EC\u30C3\u30B9\u30F3\u304C\u5C4A\u304D\u307E\u3059\u2728")))));
};
const styles = StyleSheet.create({
    container: {},
    title: {
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: '0.04em',
        color: Colors.Black,
    },
    titleGray: {
        color: Colors.GrayDarkest,
    },
    daysCount: {
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '160%',
        letterSpacing: '0.04em',
        color: Colors.GrayDarkest,
    },
});
